"use client"
import { motion } from "motion/react"
import { ArrowRight, Shield, Clock } from "lucide-react"
import { scrollToSellWatchForm, navigateToContact } from "@/lib/scroll-utils"
import { useDialog } from "@/contexts/dialog-context"

export default function CTA(){
    const { openDialog } = useDialog()
    
    const handleFormCTAClick = () => {
        scrollToSellWatchForm(() => openDialog())
    }
    
    return(
        <>
        <section className="wrapper pb-small">
            <div className="flex flex-col w-full max-w-screen-2xl">
                
                {/* Main CTA Block */}
                <motion.div 
                    className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12 py-12 lg:py-16 px-6 lg:px-12 bg-foreground rounded-2xl relative overflow-hidden"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ 
                        opacity: 1, 
                        y: 0,
                        transition: { duration: 0.4 } 
                    }}
                >
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-5">
                        <div className="absolute top-4 right-8 text-background text-6xl font-bold">£</div>
               
                    </div>
                    
                    {/* Content */}
                    <div className="flex flex-col gap-4 max-w-2xl text-center lg:text-left relative z-10">
                        <div className="space-y-3">
                            <h2 className="text-h2 text-background">
                                Ready to Sell Your Luxury Watch?
                            </h2>
                            <p className="text-large text-background/80 text-balance">
                                Get your free, professional valuation today. Our experts are standing by to give you the best price for your timepiece.
                            </p>
                        </div>
                        
                        {/* Trust Indicators */}
                        <div className="flex flex-wrap gap-6 justify-center lg:justify-start">
                            <div className="flex items-center gap-2">
                                <Shield className="w-5 h-5 text-background/70" />
                                <span className="text-small text-background/70">15+ Years Experience</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <Clock className="w-5 h-5 text-background/70" />
                                <span className="text-small text-background/70">24hr Response</span>
                            </div>
                        </div>
                    </div>
                    
                    {/* CTA Buttons */}
                    <div className="flex flex-col gap-4 w-full lg:w-auto lg:min-w-fit relative z-10">
                        <button 
                            onClick={handleFormCTAClick}
                            className="inline-flex items-center justify-center gap-2 bg-background text-foreground hover:bg-background/90 h-12 px-8 py-3 rounded-xl text-body font-medium transition-colors group"
                        >
                            Get Your Free Quote Today
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </button>
                        <button 
                            onClick={navigateToContact}
                            className="inline-flex items-center justify-center gap-2 border border-background/30 bg-transparent text-background hover:bg-background/10 h-12 px-8 py-3 rounded-xl text-body font-medium transition-colors"
                        >
                            Visit Us
                        </button>
                    </div>
                </motion.div>
                
                {/* Stats Row */}
                <motion.div 
                    className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-12 text-center pb-small lg:pb-large"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ 
                        opacity: 1, 
                        y: 0,
                        transition: { duration: 0.3, delay: 0.2 } 
                    }}
                >
                    {stats.map((stat, index) => (
                        <div 
                            key={index} 
                            className={`space-y-1 ${index < stats.length - 1 ? 'border-b border-muted-foreground/20 pb-6 md:border-b-0 md:pb-0' : ''}`}
                        >
                            <div className="text-h2 text-cta font-bold">
                                {stat.value}
                            </div>
                            <div className="text-body text-muted-foreground">
                                {stat.label}
                            </div>
                            
                        </div>
                    ))}
                </motion.div>

                {/* Bottom CTA 
                <motion.div 
                    className="flex flex-col items-center gap-3 pt-large pb-large text-center"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ 
                        opacity: 1, 
                        y: 0,
                        transition: { duration: 0.3, delay: 0.5 } 
                    }}
                >
                    <h3 className="text-h3">
                        Still Have Questions?
                    </h3>
                    <p className="text-large text-muted-foreground max-w-xl text-balance">
                        Our watch experts are here to help. Contact us for personalized assistance with your luxury timepiece.
                    </p>
                    <button 
                        onClick={navigateToContact}
                        className="inline-flex items-center justify-center gap-2 bg-cta text-primary-foreground hover:bg-cta/90 h-10 px-6 py-2 rounded-xl text-body font-medium transition-colors mt-1"
                    >
                        Contact Our Experts
                    </button>
                </motion.div>
                */}
                
            </div>
        </section>
        </>
    )
}

const stats = [
    {
        value: "15+",
        label: "Years of Experience"
    },
    {
        value: "10,000+",
        label: "Watches Purchased"
    },
    {
        value: "5,000+",
        label: "Happy Customers"
    }
];
